import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import SupportPage from './SupportPage';

const SupportRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    console.log('SupportRoutes path', path);
    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={SupportPage} />
            </Switch>
        </>
    );
};

export default SupportRoutes;
